export const NS_TOUCHWEB = 'touchWeb';
export const NS_ATTRIBUTES = 'attributes';

export const DEFAULT_LANGUAGE = 'sv';
export const URL_LANGUAGES = ['en', 'de', 'da'];

export const I18N_NAMESPACES = [NS_TOUCHWEB, NS_ATTRIBUTES];
export const NAMESPACE_PROJECTID = {
    [NS_TOUCHWEB]: '414441505e1db31fcaa776.55234720',
    [NS_ATTRIBUTES]: '9959867960be20fdc7d187.66761514'
};

export const SUPPORTED_LANGUAGES = [DEFAULT_LANGUAGE, ...URL_LANGUAGES];

export const TRANS_SUFFIX = 'Trans';
